export default "__VITE_ASSET__13e00292__"